import { render, staticRenderFns } from "./booking-header.vue?vue&type=template&id=3083b128&scoped=true&"
import script from "./booking-header.vue?vue&type=script&lang=js&"
export * from "./booking-header.vue?vue&type=script&lang=js&"
import style0 from "./booking-header.vue?vue&type=style&index=0&id=3083b128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083b128",
  null
  
)

export default component.exports